import React from "react";
import styled from "styled-components";

export default function HomeAbout() {
  return (
    <Styles>
      <div className="about-container">
        <h1>About Me</h1>
        <br></br>
        <p>
          Hi, my name is Ivy Pratiwi. I completed my Master of Information
          Technology, focusing on front end development and data science at
          Queensland University of Technology (QUT). These areas I found later
          after a short stint working in accounting which I am now extremely
          passionate about. You will see my past front-end and data science
          projects below. I'm also interested to link with others who have
          similar interests. So, please contact me through the contact form
          which you can find in the navigation bar.
        </p>
        <p>
          A bit about me. I have lived in four different countries. I spent most
          of my time in Indonesia and then moved to Singapore for 5 years where
          I completed my bachelor degree and worked professionally in
          Accounting. Feeling the need to study further, I went to China to
          learn Chinese language for a year and I am now here in Australia doing
          my master. In my free time, I enjoy taking a quick walk in the park. I
          find this helps me relaxing and lifting my mood. I also have passion
          in music including singing and playing musical instruments.
        </p>
      </div>
    </Styles>
  );
}

const Styles = styled.div`
  .about-container {
    padding: 3% 15% 3% 15%;
    text-align: justify;
    text-align-last: center;
  }

  @media (min-width: 2200px) {
    p {
      font-size: 130%;
    }
  }

  @media (max-width: 576px) {
    h1 {
      font-size: 190%;
    }
  }
`;
